export default function LinePattern(props: { class: string }) {
    // return <svg
    //     className={props.class}
    //     id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='scale(2) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/><path d='M15 22h10m-10-4h10M35 2h10M35 38h10m-50 0H5M-5 2H5'  strokeLinecap='square' strokeWidth='1' stroke='hsla(0, 0%, 0%, 1)' fill='none'/><path d='M18-5V5m4-10V5m16 10v10M18 35v10m4-10v10M2 15v10'  strokeLinecap='square' strokeWidth='1' stroke='hsla(78, 59%, 55%, 1)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(#a)'/></svg>

    return <svg id='patternId'
                className={props.class}
                width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'>
        <defs>
            <pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40'
                     patternTransform='scale(1) rotate(0)'>
                <rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/>
                <path d='M20-5V5m0 30v10m20-30v10M0 15v10' strokeLinecap='square' strokeWidth='1'
                      stroke='hsla(78, 59%, 55%, 1)' fill='none'/>
                <path d='M-5 40H5M-5 0H5m30 0h10M35 40h10M15 20h10' strokeLinecap='square' strokeWidth='1'
                      stroke='hsla(231, 15%, 24%, 1)' fill='none'/>
            </pattern>
        </defs>
        <rect width='800%' height='800%' transform='translate(0,0)' fill='url(#a)'/>
    </svg>
}